/** Addresses a delegate cannot open, including by typing the URL. */
export const DELEGATE_RESTRICTED_PATH_PREFIXES = [
  '/sandbox',
  '/challenges',
  '/discussions',
  '/consumer/my-projects',
  '/provider/my-projects',
  '/org-admin/my-projects',
  '/consumer/delegation-activities',
  '/provider/delegation-activities',
  '/org-admin/delegation-activities',
  '/admin/delegation-activities',
  '/consumer/profile',
  '/provider/profile',
  '/org-admin/profile',
  '/admin/profile',
  '/consumer/support',
  '/provider/support',
  '/org-admin/support',
  '/admin/support',
  '/admin/analytics-dashboard',
] as const;

/** True when a delegate should be sent home instead of opening this address. */
export function isDelegateRestrictedPath(url: string): boolean {
  const path = (url || '').split('?')[0];
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (clean.endsWith('/conversation')) return true;
  return DELEGATE_RESTRICTED_PATH_PREFIXES.some(
    (prefix) => clean === prefix || clean.startsWith(`${prefix}/`),
  );
}
